export const NAMESPACE = 'suspenseAccounts'
